import React from 'react'

import { CardType } from 'types/deck'

import { CardText, manaArrayToElement } from 'components/misc/customIcons/ManaSymbol/helpers'

import styles from './cardLoader.module.scss'

type Props = {
  loading?: boolean
  card?: CardType
  className?: string
  style?: React.CSSProperties
  includeName?: boolean
  includeText?: boolean
  includeManaCost?: boolean
  flipped?: boolean
}

const CardLoader = React.forwardRef((props: Props, ref: any) => {
  const {
    loading = false,
    card,
    className,
    style,
    includeName = true,
    includeText = false,
    includeManaCost = false,
    flipped = false,
  } = props

  if (!loading) return null

  let cardFace = card

  if (card?.front && !flipped) cardFace = card.front
  else if (card?.back && flipped) cardFace = card.back

  const name = cardFace?.name || ''
  const castingCost = cardFace?.castingCost || []
  const power = cardFace?.power || ''
  const toughness = cardFace?.toughness || ''
  const loyalty = cardFace?.loyalty || ''

  const superTypes = (cardFace?.superTypes || []).join(' ')
  const types = (cardFace?.types || []).join(' ')
  const subTypes = (cardFace?.subTypes || []).join(' ')

  const typeTextBox = `${superTypes} ${types} ${subTypes.length ? '- ' : ''}${subTypes}`

  const rawText = cardFace?.text || ''

  const nameBoxFontSize = titleBoxFontSizeHelper(name)
  const typeBoxFontSize = titleBoxFontSizeHelper(typeTextBox)
  const textBoxFontSize = textBoxFontSizeHelper(rawText)

  return (
    <div ref={ref} className={`${styles.container} ${className}`} style={style}>
      <div className={styles.namebox} style={{ opacity: includeName ? 1 : 0 }}>
        <span style={{ fontSize: nameBoxFontSize, fontStyle: !name && !!card?.customCard ? 'italic' : undefined }}>
          {name || (!!card?.customCard ? 'Unknown or removed' : '')}
        </span>
        {includeManaCost && <span className={styles.manaCost}>{manaArrayToElement(castingCost)}</span>}
      </div>
      <div className={styles.textbox} title={typeTextBox}>
        <div
          title={rawText}
          className={styles.cardText}
          style={{ opacity: includeText ? 1 : 0, fontSize: textBoxFontSize }}>
          <CardText input={rawText} />
        </div>
      </div>
      <div className={styles.typebox} style={{ opacity: includeText ? 1 : 0, fontSize: typeBoxFontSize }}>
        {typeTextBox}
      </div>
      {includeText && types.includes('Creature') && (
        <div className={styles.powerToughness}>
          {power || 0} / {toughness || 0}
        </div>
      )}

      {includeText && types.includes('Planeswalker') && !types.includes('Creature') && (
        <div className={styles.powerToughness}>{loyalty || 0}</div>
      )}

      <div className={styles.archidektLogo} />
    </div>
  )
})

export default CardLoader

const titleBoxFontSizeHelper = (text: string): number => {
  if (text.length < 25) return 12
  if (text.length < 35) return 11
  if (text.length < 45) return 10
  if (text.length < 55) return 9
  if (text.length < 65) return 8

  return 7
}

const textBoxFontSizeHelper = (text: string): number => {
  if (text.length < 100) return 12
  if (text.length < 150) return 11
  if (text.length < 200) return 10
  if (text.length < 250) return 9
  if (text.length < 300) return 8

  return 7
}
